import * as React from "react";
import { Row, Col } from "reactstrap";
import "../../style/style.scss";
import LoanDetails from "./LoanDetails";
import { FormStep, Step } from "../../store/application/applicationState";
import ApplicationHeader from "../applicationHeader";
import Children from "./Children";

export interface HeaderProps {
    formStep: FormStep;
    step: Step;
}

type Props = HeaderProps;

class Header extends React.Component<Props, {}> {
    render() {

    return (
      <ApplicationHeader>
        <Row>
          <Col className="col-12">
            <LoanDetails />
                </Col>
            </Row>
            <br />
      </ApplicationHeader>
    );
  }
}

export default Header;
